import classNames from 'classnames';
import NotificationItem from './NotificationItem';
import { useLayout } from '../../hooks/context/useLayout';
import { useNotification } from '../../hooks/context/useNotification';

const NotificationContainer = () => {
  const {showNotification, closeNotification} = useLayout();
  const {notificationList, removeNotificationItem} = useNotification();

  return (
    <div className={classNames({'menu-notification': true, 'show': showNotification})}>
      <div className="head-notification">
        <p className="title-notification">
          Notifications <span className="count-notif">{notificationList.length ?? 0}</span>
        </p>
        {/* close notification button */}
        <span className="icon-close-dark" onClick={closeNotification}/> 
      </div>
      <div className="list-notifications">
        {notificationList.length ? 
          notificationList.map((notification, index) => 
            <NotificationItem
                key={index}
                icon={notification.icon}
                path={notification.path}
                title={notification.title}
                subtitle={notification.subtitle}
                onRemoveClick={() => removeNotificationItem(notification)}
            />
          ) : <span className='d-flex justify-content-center mt-3'>No notifications</span>
        }
      </div>
    </div>
  )
}

export default NotificationContainer;